import React, { useState } from "react";
import { Button } from "react-bootstrap";
import CMSTestimonalTableModal from "./CMSTestimonalTableModal";

const CMSTestimonalTable = ({
  username,
  setUsername,
  data,
  setData,
  image,
  setImage,
  imageFile,
  setImageFile,
  description,
  setDescription,
  handleSelectImage,
  location,
  setLocation,
  handleDeleteTestimonal,
}) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="card shadow mb-3">
      <div className="col-md-12 cms-table mt-3">
        <div className="d-flex mb-3 justify-content-between">
          <h3 className="ml-3 mr-3">Testimonials</h3>
          <button className="btn pick-image" onClick={() => setOpenModal(true)}>
            {" "}
            + Add Testimonial
          </button>
        </div>
        <table class="table ml-2">
          <thead class="thead-light">
            <tr>
              <th scope="col">S.No</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Location</th>
              <th scope="col">Image</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((e, i) => {
              return (
                <tr>
                  <th scope="row">{i+1}</th>
                  <td>{e?.name}</td>
                  <td>{e?.description}</td>
                  <td>{e?.location}</td>
                  <td><img src={e?.image}  className="cms__tableImage"/></td>
                  <td>
                    <button
                      className="btn decline-btn"
                      onClick={() => {
                        handleDeleteTestimonal(e, i);
                      }}
                    >
                      {"Remove"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* CMSTestimonalTableModal */}
        <CMSTestimonalTableModal
          username={username}
          setUsername={setUsername}
          data={data}
          setData={setData}
          open={openModal}
          setOpen={setOpenModal}
          image={image}
          setImage={setImage}
          imageFile={imageFile}
          setImageFile={setImageFile}
          description={description}
          setDescription={setDescription}
          location={location}
          setLocation={setLocation}
          handleSelectImage={handleSelectImage}
          handleDeleteTestimonal={handleDeleteTestimonal}
        />
      </div>
    </div>
  );
};

export default CMSTestimonalTable;
